import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Lock, Zap, ShieldCheck, CreditCard } from 'lucide-react';
export function FinalCTASection() {
  return <section className="bg-nightDeep py-12 text-white relative overflow-hidden" data-id="element-75">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-76">
        <div className="absolute top-[-20%] left-[-10%] w-[50%] h-[50%] rounded-full bg-gold-accent opacity-5 blur-[120px]" data-id="element-77"></div>
        <div className="absolute bottom-[-20%] right-[-10%] w-[50%] h-[50%] rounded-full bg-purple-500 opacity-10 blur-[120px]" data-id="element-78"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-79">
        <div className="text-center mb-8" data-id="element-80">
          <div className="inline-flex items-center justify-center gap-2 px-4 py-1.5 rounded-full bg-red-500/15 text-red-400 font-bold text-sm tracking-wider mb-4 border border-red-500/30" data-id="element-81">
            <Clock className="w-4 h-4" data-id="element-82" /> EL PRECIO CIERRA PRONTO
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-8" data-id="element-83">
          <motion.a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNBtcGR5gY46xHK2dK4UqNG/es-ar?_r=AQABw5ZcyHnPWzbkFPYt-XxWxAHJ1loDHKYYqHQJdUs8y4U&cart_link_id=ZO9PHgFE&preview_theme_id=154123698339" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="glass rounded-2xl p-6 text-center hover:bg-white/10 transition-all block group" data-id="element-84">
            <h3 className="text-xl font-bold text-white mb-1" data-id="element-85">
              📘 COLECCIÓN BASE
            </h3>
            <p className="text-2xl font-bold text-textLight mb-4" data-id="element-86">
              $19.990 ARS
            </p>
            <p className="text-sm text-textLight/80 mb-6" data-id="element-87">6 Tomos + 6 Bonos</p>
            <div className="bg-white/10 border border-white/20 text-white font-bold py-3 rounded-xl group-hover:bg-white/20 transition-colors" data-id="element-88">
              → QUIERO MI COLECCIÓN
            </div>
          </motion.a>

          <motion.a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNBtcc5gQMviKiNAt4F1mGw/es-ar?_r=AQAB9MQu5iuNkd59BCbXucAS8Tqairno5W_7ASEfkqp3m44&cart_link_id=t8H58Iw6&preview_theme_id=154123698339" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="glass rounded-2xl p-6 text-center hover:bg-gold-accent/10 transition-all block group relative border-2" style={{
          borderColor: '#E0B24C'
        }} data-id="element-89">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gold-accent text-night text-xs font-bold px-3 py-1 rounded-full" data-id="element-90">
              MÁS ELEGIDA
            </div>
            <h3 className="text-xl font-bold text-gold-accent mb-1" data-id="element-91">
              🏆 COLECCIÓN + PRO
            </h3>
            <p className="text-2xl font-bold text-white mb-4" data-id="element-92">$27.990 ARS</p>
            <p className="text-sm text-textLight/80 mb-6" data-id="element-93">
              6 Tomos + 6 Bonos + Manual Pro
            </p>
            <div className="bg-gold-btn text-night font-bold py-3 rounded-xl group-hover:bg-gold-btnHover transition-colors shadow-[0_0_20px_rgba(224,178,76,0.4)]" data-id="element-94">
              → QUIERO LA COLECCIÓN + PRO
            </div>
          </motion.a>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-8 gap-y-4 text-sm text-textLight" data-id="element-95">
          <span className="flex items-center gap-2" data-id="element-96">
            <Lock className="w-4 h-4 text-gold-accent" data-id="element-97" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-98">
            <Zap className="w-4 h-4 text-gold-accent" data-id="element-99" /> Acceso en 5 min
          </span>
          <span className="flex items-center gap-2" data-id="element-100">
            <ShieldCheck className="w-4 h-4 text-gold-accent" data-id="element-101" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-2" data-id="element-102">
            <CreditCard className="w-4 h-4 text-gold-accent" data-id="element-103" /> Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}